import React, { useEffect, useState, useMemo } from "react";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import ItemMasterSerialEditModal from "../components/itemMasterSerialEditModal";

const ItemSerialNo = () => {
  useAuthRedirect();
  const { item } = useParams();
  const branch = localStorage.getItem("branch");

  const [stockData, setStockData] = useState([]);   // ✅ Stock details
  const [serialData, setSerialData] = useState([]); // ✅ Serial numbers
  const [filteredSerial, setFilteredSerial] = useState([]); // ✅ For search on serials
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);

  /////////////////////////////////////////////////////////////
        const rawPerms = useMemo(() => localStorage.getItem("permissions") || localStorage.getItem("userPermissions"), []);
          const permsLoaded = !!rawPerms;
          
          //✅ Permission checks (safe even if perms not yet loaded; will be false)
          const canEdit = hasPermission("Item", "edit");
          /////////////////////////////////////////////////////////////
    

  // Fetch stock details
  useEffect(() => {
    fetchStock();
  }, [item]);

  const fetchStock = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://rfs2.infraconsoft.net.in/api/itemMaster_itemSerial?item=${item}`
      );
      setStockData(response.data.itemList || []);
    } catch (error) {
      console.error("Error fetching stock:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch serial numbers
  useEffect(() => {
    fetchSerial();
  }, [item, branch]);

  const fetchSerial = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://rfs2.infraconsoft.net.in/api/itemMaster_getSerial?item=${item}&branch=${branch}`
      );
      const serials = response.data.getSerial || [];
      setSerialData(serials);
      setFilteredSerial(serials);
    } catch (error) {
      console.error("Error fetching serials:", error);
    } finally {
      setLoading(false);
    }
  };

  // Search only in serial numbers
  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    if (term === "") {
      setFilteredSerial(serialData);
      return;
    }

    const filtered = serialData.filter((s) =>
      String(s.serial || "").toLowerCase().includes(term)
    );
    setFilteredSerial(filtered);
  };

  // Pagination for serial numbers
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentSerials = filteredSerial.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  // Modal for editing serials
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editFormData, setEditFormData] = useState({
    id: "",
    itemCode: "",
    serialNo: "",
  });

  const openEditModal = (item) => {
    setEditFormData({
      id: item.id,
      itemCode: item.itemcode,
      serialNo: item.serial,
    });
    setIsEditModalOpen(true);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
  };

    if (!canEdit) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <div className="back-div">
            <h2 className="add-txt">Serial Number Management</h2>
            <Link to="/inventory/itemmasterviewnew">
              <p className="back-button">
                <i className="fa-solid fa-backward"></i>Back
              </p>
            </Link>
          </div>
          <Time />
        </section>

        {/* Search Filter (only for serials) */}
        <div className="search-filter">
          <p>Search Serial: </p>
          <input
            type="text"
            placeholder="Search by Serial Number"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Stock Table */}
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Branch Code</th>
                <th>Opening Stock</th>
                <th>Closing Stock</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="4" className="loading-text">
                    Loading data, please wait...
                  </td>
                </tr>
              ) : stockData.length > 0 ? (
                <>
                  {stockData.map((item1, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item1.branchCode}</td>
                      <td>{item1.itemmaster_openingStock}</td>
                      <td>{item1.itemmaster_closingStock}</td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan={3}>
                      <strong>Total</strong>
                    </td>
                    <td>
                      <strong>
                        {stockData.reduce(
                          (sum, item) =>
                            sum + parseFloat(item.itemmaster_closingStock || 0),
                          0
                        )}
                      </strong>
                    </td>
                  </tr>
                </>
              ) : (
                <tr>
                  <td colSpan="4">No Stock Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Serial Numbers Table */}
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Serial Number</th>
                <th>Edit</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="3" className="loading-text">
                    Loading data, please wait...
                  </td>
                </tr>
              ) : currentSerials.length > 0 ? (
                currentSerials.map((s, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{s.serial}</td>
                    <td
                      style={{
                        fontWeight: "bold",
                        color: "blue",
                        cursor: "pointer",
                      }}
                      onClick={() => openEditModal(s)}
                    >
                      Edit
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3">No Serial Numbers Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination for serials */}
        <div className="pagination">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          {[...Array(Math.ceil(filteredSerial.length / itemsPerPage))].map(
            (_, index) => (
              <button
                key={index + 1}
                onClick={() => paginate(index + 1)}
                className={currentPage === index + 1 ? "active" : ""}
              >
                {index + 1}
              </button>
            )
          )}
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={
              currentPage === Math.ceil(filteredSerial.length / itemsPerPage)
            }
          >
            Next
          </button>
        </div>
      </div>

      {/* Edit Modal */}
      <ItemMasterSerialEditModal
        isOpen={isEditModalOpen}
        onClose={closeEditModal}
        editFormData={editFormData}
        setEditFormData={setEditFormData}
        fetchData={fetchSerial} // ✅ refresh serials after edit
      />
    </div>
  );
};

export default ItemSerialNo;
